import { render } from "./multi-dynamic.vue?vue&type=template&id=f0a4a42e&lang=pug"
import script from "./multi-dynamic.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-dynamic.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__